
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Pagination,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment,
//   Snackbar,
//   Alert,
//   IconButton,
//   useMediaQuery,
//   useTheme,
//   Button,
// } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../../../Commonlibs/userSlice';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CloseIcon from '@mui/icons-material/Close';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import ShareIcon from '@mui/icons-material/Share';
// // Import loader
// import Loader from '../../../Loader/Loader';

// const outfitFontStyle = {
//   fontFamily: 'Outfit, sans-serif',
// };

// const ProfileViewed = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const itemsPerPage = 5;

//   // Share dialog states
//   const [shareDialog, setShareDialog] = useState(false);
//   const [shareUrl, setShareUrl] = useState('');
//   const [selectedPropertyId, setSelectedPropertyId] = useState(null);

//   // Favorites state - track favorites for each property
//   const [favorites, setFavorites] = useState({});

//   // Toast notification state
//   const [toast, setToast] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const navigate = useNavigate();
//   const user = useSelector(selectUser);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isLoggedIn = !!user?.token;

//   useEffect(() => {
//     const fetchViewedProperties = async () => {
//       try {
//         setLoading(true);
//         const buyer_id = user?.id;
       
//         const response = await axios.get(
//           `https://propertydealstalk.com/api/buyerAnalytics/getBuyerDashboardPropertiesByType?buyer_id=${buyer_id}&type=recently_viewed`
//         );
       
//         if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
//           const processedProperties = response.data.result.map(property => {
//             const hasImage = hasValidImage(property);
//             return {
//               ...property,
//               hasValidImage: hasImage,
//               processedImageUrl: hasImage ? getPropertyImage(property) : null
//             };
//           });
//           setProperties(processedProperties);
//           setTotalPages(Math.ceil(processedProperties.length / itemsPerPage));
          
//           // Check favorite status for all properties
//           if (isLoggedIn && user?.id) {
//             checkAllFavoriteStatus(processedProperties);
//           }
//         } else {
//           setError(response.data.message || "Failed to fetch properties");
//         }
//       } catch (err) {
//         setError("Error fetching viewed properties");
//         console.error("Error fetching viewed properties:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchViewedProperties();
//   }, [user, isLoggedIn]);

//   // Check favorite status for all properties
//   const checkAllFavoriteStatus = async (propertiesToCheck) => {
//     if (!isLoggedIn || !user?.id) {
//       return;
//     }

//     try {
//       const response = await fetch(
//         `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${user.id}`
//       );
//       const data = await response.json();

//       if (data.statusCode === 200 && data.result) {
//         const favoritesList = Array.isArray(data.result) ? data.result : [];
//         const favoritesMap = {};
        
//         propertiesToCheck.forEach(property => {
//           const isInFavorites = favoritesList.some(
//             fav => fav.property?.id === parseInt(property.id) || fav.property_id === parseInt(property.id)
//           );
//           favoritesMap[property.id] = isInFavorites;
//         });
        
//         setFavorites(favoritesMap);
//         console.log('✅ Favorites checked:', favoritesMap);
//       }
//     } catch (err) {
//       console.error('Error checking favorite status:', err);
//     }
//   };

//   // Toggle favorite for a specific property
//   const toggleFavorite = async (e, property) => {
//     e.stopPropagation();
    
//     if (!isLoggedIn) {
//       navigate('/login');
//       return;
//     }

//     const propertyId = property.id;
//     const isFavorite = favorites[propertyId] || false;

//     try {
//       if (isFavorite) {
//         // Remove from favorites
//         const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: user?.id,
//             property_id: parseInt(propertyId)
//           })
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setFavorites(prev => ({ ...prev, [propertyId]: false }));
//           setToast({
//             open: true,
//             message: 'Property removed from favorites successfully',
//             severity: 'success'
//           });
//           console.log('✅ Property removed from favorites');
//         } else {
//           throw new Error(data.message || 'Failed to remove property from favorites');
//         }
//       } else {
//         // Add to favorites
//         const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             buyer_id: user?.id,
//             property_id: parseInt(propertyId)
//           })
//         });

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setFavorites(prev => ({ ...prev, [propertyId]: true }));
//           setToast({
//             open: true,
//             message: 'Property added to favorites successfully',
//             severity: 'success'
//           });
//           console.log('✅ Property added to favorites');
//         } else {
//           throw new Error(data.message || 'Failed to add property to favorites');
//         }
//       }
//     } catch (err) {
//       console.error('Error toggling favorite:', err);
//       setToast({
//         open: true,
//         message: err.message || 'Failed to update favorites',
//         severity: 'error'
//       });
//     }
//   };

//   // Check if property has valid image
//   const hasValidImage = (property) => {
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       return true;
//     }
//     if (property.primary_image && property.primary_image.length > 100) {
//       return true;
//     }
//     if (property.images && typeof property.images === 'string' && property.images.length > 100) {
//       return true;
//     }
//     return false;
//   };

//   // Get property image with proper base64 formatting
//   const getPropertyImage = (property) => {
//     if (property.image && 
//         property.image.length > 100 && 
//         property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
//       if (property.image.startsWith('data:image/')) {
//         return property.image;
//       }
//       return `data:image/jpeg;base64,${property.image}`;
//     }
//     if (property.primary_image && property.primary_image.length > 100) {
//       if (property.primary_image.startsWith('data:image/')) {
//         return property.primary_image;
//       }
//       return `data:image/jpeg;base64,${property.primary_image}`;
//     }
//     if (property.images && typeof property.images === 'string' && property.images.length > 100) {
//       if (property.images.startsWith('data:image/')) {
//         return property.images;
//       }
//       return `data:image/jpeg;base64,${property.images}`;
//     }
//     return null;
//   };

//   // Get current page items
//   const getCurrentPageItems = () => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return properties.slice(startIndex, endIndex);
//   };

//   // Handle page change
//   const handlePageChange = (event, value) => {
//     setPage(value);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Format price with commas
//   const formatPrice = (price) => {
//     if (!price) return '0';
//     return '₹' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   // Handle navigation to property details
//   const handlePropertyClick = (propertyId) => {
//     navigate(`/view/${propertyId}`);
//   };

//   // Share handlers - matching TalkView.jsx
//   const handleShareClick = async (e, property) => {
//     e.stopPropagation();
//     const publicUrl = `${window.location.origin}/view/${property.id}`;
    
//     const shareData = {
//       title: property?.property_name || 'Property on PropertyDealsTalk',
//       text: `Check out ${property?.property_name || 'this property'} - ${formatPrice(property?.asking_price)} at ${property?.location || 'prime location'}`,
//       url: publicUrl
//     };

//     if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
//       try {
//         await navigator.share(shareData);
//         setToast({
//           open: true,
//           message: 'Shared successfully!',
//           severity: 'success'
//         });
//       } catch (err) {
//         if (err.name !== 'AbortError') {
//           setShareUrl(publicUrl);
//           setSelectedPropertyId(property.id);
//           setShareDialog(true);
//         }
//       }
//     } else {
//       setShareUrl(publicUrl);
//       setSelectedPropertyId(property.id);
//       setShareDialog(true);
//     }
//   };

//   const handleCopyUrl = async () => {
//     try {
//       await navigator.clipboard.writeText(shareUrl);
//       setToast({
//         open: true,
//         message: 'URL copied to clipboard!',
//         severity: 'success'
//       });
//     } catch (err) {
//       setToast({
//         open: true,
//         message: 'Failed to copy URL',
//         severity: 'error'
//       });
//     }
//   };

//   const handleCloseShareDialog = () => {
//     setShareDialog(false);
//     setSelectedPropertyId(null);
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === 'clickaway') return;
//     setToast(prev => ({ ...prev, open: false }));
//   };

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         background: '#fff',
//         borderRadius: '16px',
//         width: '100%',
//         maxWidth: '1100px',
//         p: { xs: '16px', md: '24px' },
//         boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//         mb: '24px',
//         boxSizing: 'border-box',
//         overflowX: 'hidden',
//       }}
//     >
//       {error ? (
//         <Box sx={{ textAlign: 'center', p: 3 }}>
//           <Typography color="error">{error}</Typography>
//         </Box>
//       ) : properties.length === 0 ? (
//         <Box sx={{ textAlign: 'center', p: 3 }}>
//           <Typography>No recently viewed properties found.</Typography>
//         </Box>
//       ) : (
//         <>
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '30px',
//             }}
//           >
//             {getCurrentPageItems().map((property) => {
//               const isFavorite = favorites[property.id] || false;
              
//               return (
//                 <Box
//                   key={property.id}
//                   sx={{
//                     display: 'flex',
//                     flexDirection: { xs: 'column', md: 'row' },
//                     background: '#fff',
//                     border: '1px solid #ddd',
//                     borderRadius: '12px',
//                     overflow: 'hidden',
//                     height: { md: '140px', xs: 'auto' },
//                     width: '100%',
//                     cursor: 'pointer',
//                     transition: 'transform 0.2s, box-shadow 0.2s',
//                     '&:hover': {
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                     },
//                   }}
//                   onClick={() => handlePropertyClick(property.id)}
//                 >
//                   {/* Property Image */}
//                   <Box
//                     sx={{
//                       width: { md: '300px', xs: '100%' },
//                       height: { md: '140px', xs: '180px' },
//                       flexShrink: 0,
//                       position: 'relative',
//                     }}
//                   >
//                     {property.hasValidImage ? (
//                       <Box
//                         component="img"
//                         src={property.processedImageUrl}
//                         alt={property.property_name || 'Property Image'}
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           objectFit: 'cover',
//                           borderTopLeftRadius: { md: '8px', xs: 0 },
//                           borderBottomLeftRadius: { md: '8px', xs: 0 },
//                         }}
//                       />
//                     ) : (
//                       <Box
//                         sx={{
//                           width: '100%',
//                           height: '100%',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           border: '1px dashed #ccc',
//                           borderTopLeftRadius: { md: '8px', xs: 0 },
//                           borderBottomLeftRadius: { md: '8px', xs: 0 },
//                         }}
//                       >
//                         <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                           No images uploaded
//                         </Typography>
//                       </Box>
//                     )}
//                   </Box>

//                   {/* Property Details */}
//                   <Box
//                     sx={{
//                       flex: 1,
//                       ml: { md: '20px', xs: 0 },
//                       p: { xs: '16px', md: '10px' },
//                       display: 'flex',
//                       flexDirection: 'column',
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'flex-start',
//                         mb: 1,
//                       }}
//                     >
//                       <Box sx={{ flex: 1 }}>
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             ...outfitFontStyle,
//                             fontWeight: 600,
//                             fontSize: '18px',
//                             mb: 0.5,
//                           }}
//                         >
//                           {property.property_name || 'Unnamed Property'}
//                         </Typography>
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             ...outfitFontStyle,
//                             fontWeight: 700,
//                             color: '#3b82f6',
//                             mb: 1,
//                             fontSize: '18px',
//                           }}
//                         >
//                           {formatPrice(property.asking_price)}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             ...outfitFontStyle,
//                             color: '#6b7280',
//                             fontSize: '14px',
//                             mb: 0.5,
//                           }}
//                         >
//                           {property.area_name || ''}{property.area_name && property.location ? ', ' : ''}{property.location || ''}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             ...outfitFontStyle,
//                             color: '#6b7280',
//                             fontSize: '14px',
//                           }}
//                         >
//                           {property.property_type === 'residential' ? 'Residential' : 'Commercial'} {property.asset_type || ''}
//                         </Typography>
//                       </Box>

//                       {/* Save and Share Buttons - Matching TalkView.jsx */}
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           gap: 3,
//                           ml: 2,
//                           alignItems: 'center',
//                         }}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         {/* Save Button */}
//                         <Box
//                           display="flex"
//                           alignItems="center"
//                           gap={1}
//                           sx={{ cursor: 'pointer' }}
//                           onClick={(e) => toggleFavorite(e, property)}
//                         >
//                           {isFavorite ? (
//                             <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
//                           ) : (
//                             <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
//                           )}
//                           <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
//                             {isFavorite ? 'Saved' : 'Save'}
//                           </Typography>
//                         </Box>

//                         {/* Share Button */}
//                         <Box
//                           display="flex"
//                           alignItems="center"
//                           gap={1}
//                           sx={{ cursor: 'pointer' }}
//                           onClick={(e) => handleShareClick(e, property)}
//                         >
//                           <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
//                           <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
//                             Share
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Box>

//                     {/* Property Details - Hide on Mobile */}
//                     {!isMobile && (
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           gap: '120px',
//                           mt: 'auto',
//                         }}
//                       >
//                         {property.bhk && (
//                           <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
//                             {property.bhk} BHK
//                           </Typography>
//                         )}
//                         {property.furnish_type && (
//                           <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
//                             {property.furnish_type}
//                           </Typography>
//                         )}
//                         {property.property_size && (
//                           <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
//                             {property.property_size} {property.property_size_units || 'sq.ft'}
//                           </Typography>
//                         )}
//                       </Box>
//                     )}
//                   </Box>
//                 </Box>
//               );
//             })}
//           </Box>
         
//           {/* Pagination */}
//           {totalPages > 1 && (
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//               <Pagination
//                 count={totalPages}
//                 page={page}
//                 onChange={handlePageChange}
//                 color="primary"
//                 size="medium"
//                 showFirstButton
//                 showLastButton
//                 sx={{
//                   '& .MuiPaginationItem-root': {
//                     ...outfitFontStyle,
//                     color: '#333',
//                   },
//                   '& .Mui-selected': {
//                     backgroundColor: '#2563EB !important',
//                     color: 'white',
//                   }
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       )}

//       {/* Share Dialog - Matching TalkView.jsx */}
//       <Dialog open={shareDialog} onClose={handleCloseShareDialog} maxWidth="sm" fullWidth>
//         <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
//             Share Property
//           </Typography>
//           <IconButton onClick={handleCloseShareDialog} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
//             Share this property link with others. Anyone with this link can view the property details.
//           </Typography>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{
//               readOnly: true,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={handleCopyUrl} edge="end" color="primary" title="Copy URL">
//                     <ContentCopyIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ 
//               '& .MuiOutlinedInput-root': { 
//                 backgroundColor: '#f5f5f5',
//                 ...outfitFontStyle 
//               } 
//             }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button 
//             onClick={handleCloseShareDialog} 
//             variant="outlined" 
//             sx={outfitFontStyle}
//           >
//             Close
//           </Button>
//           <Button 
//             onClick={handleCopyUrl} 
//             variant="contained" 
//             startIcon={<ContentCopyIcon />} 
//             sx={outfitFontStyle}
//           >
//             Copy Link
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Toast Notifications */}
//       <Snackbar
//         open={toast.open}
//         autoHideDuration={6000}
//         onClose={handleCloseToast}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', ...outfitFontStyle }}>
//           {toast.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ProfileViewed;



import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Snackbar,
  Alert,
  IconButton,
  useMediaQuery,
  useTheme,
  Button,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Commonlibs/userSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import Loader from '../../../Loader/Loader';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const ProfileViewed = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 5;

  const [shareDialog, setShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  const [favorites, setFavorites] = useState({});

  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLoggedIn = !!user?.token;

  // ✅ Helper function to check if error is network-related
  const isNetworkError = (error) => {
    const errorString = error?.toString().toLowerCase() || '';
    return (
      errorString.includes('network') ||
      errorString.includes('fetch') ||
      errorString.includes('connection') ||
      errorString.includes('timeout') ||
      error?.message?.toLowerCase().includes('network') ||
      error?.code === 'ERR_NETWORK' ||
      error?.code === 'ECONNABORTED'
    );
  };

  // ✅ Updated fetchViewedProperties with better error handling
  useEffect(() => {
    const fetchViewedProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        const buyer_id = user?.id;
       
        const response = await axios.get(
          `https://propertydealstalk.com/api/buyerAnalytics/getBuyerDashboardPropertiesByType?buyer_id=${buyer_id}&type=recently_viewed`
        );
       
        if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
          const processedProperties = response.data.result.map(property => {
            const hasImage = hasValidImage(property);
            return {
              ...property,
              hasValidImage: hasImage,
              processedImageUrl: hasImage ? getPropertyImage(property) : null
            };
          });
          setProperties(processedProperties);
          setTotalPages(Math.ceil(processedProperties.length / itemsPerPage));
          
          if (isLoggedIn && user?.id) {
            checkAllFavoriteStatus(processedProperties);
          }
        } else {
          setError(response.data.message || "Failed to fetch properties");
        }
      } catch (err) {
        console.error("Error fetching viewed properties:", err);
        // Show user-friendly message for all GET request errors
        setError("Unable to load recently viewed properties. Please check your internet connection and try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchViewedProperties();
  }, [user, isLoggedIn]);

  const checkAllFavoriteStatus = async (propertiesToCheck) => {
    if (!isLoggedIn || !user?.id) {
      return;
    }

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${user.id}`
      );
      const data = await response.json();

      if (data.statusCode === 200 && data.result) {
        const favoritesList = Array.isArray(data.result) ? data.result : [];
        const favoritesMap = {};
        
        propertiesToCheck.forEach(property => {
          const isInFavorites = favoritesList.some(
            fav => fav.property?.id === parseInt(property.id) || fav.property_id === parseInt(property.id)
          );
          favoritesMap[property.id] = isInFavorites;
        });
        
        setFavorites(favoritesMap);
        console.log('✅ Favorites checked:', favoritesMap);
      }
    } catch (err) {
      console.error('Error checking favorite status:', err);
    }
  };

  // ✅ Updated toggleFavorite with better error handling
  const toggleFavorite = async (e, property) => {
    e.stopPropagation();
    
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    const propertyId = property.id;
    const isFavorite = favorites[propertyId] || false;

    try {
      if (isFavorite) {
        const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setFavorites(prev => ({ ...prev, [propertyId]: false }));
          setToast({
            open: true,
            message: 'Property removed from favorites successfully',
            severity: 'success'
          });
          console.log('✅ Property removed from favorites');
        } else {
          // Show actual API error message
          throw new Error(data.message || 'Failed to remove property from favorites');
        }
      } else {
        const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setFavorites(prev => ({ ...prev, [propertyId]: true }));
          setToast({
            open: true,
            message: 'Property added to favorites successfully',
            severity: 'success'
          });
          console.log('✅ Property added to favorites');
        } else {
          // Show actual API error message
          throw new Error(data.message || 'Failed to add property to favorites');
        }
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
      // Check if it's a network error or API error
      const errorMessage = isNetworkError(err)
        ? 'Unable to update favorites. Please check your connection and try again.'
        : err.message || 'Failed to update favorites';
      
      setToast({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const hasValidImage = (property) => {
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      return true;
    }
    if (property.primary_image && property.primary_image.length > 100) {
      return true;
    }
    if (property.images && typeof property.images === 'string' && property.images.length > 100) {
      return true;
    }
    return false;
  };

  const getPropertyImage = (property) => {
    if (property.image && 
        property.image.length > 100 && 
        property.image !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEmoSeleaKApYsGNby651rbv2Xde1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=") {
      if (property.image.startsWith('data:image/')) {
        return property.image;
      }
      return `data:image/jpeg;base64,${property.image}`;
    }
    if (property.primary_image && property.primary_image.length > 100) {
      if (property.primary_image.startsWith('data:image/')) {
        return property.primary_image;
      }
      return `data:image/jpeg;base64,${property.primary_image}`;
    }
    if (property.images && typeof property.images === 'string' && property.images.length > 100) {
      if (property.images.startsWith('data:image/')) {
        return property.images;
      }
      return `data:image/jpeg;base64,${property.images}`;
    }
    return null;
  };

  const getCurrentPageItems = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return properties.slice(startIndex, endIndex);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const formatPrice = (price) => {
    if (!price) return '0';
    return '₹' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePropertyClick = (propertyId) => {
    navigate(`/view/${propertyId}`);
  };

  const handleShareClick = async (e, property) => {
    e.stopPropagation();
    const publicUrl = `${window.location.origin}/view/${property.id}`;
    
    const shareData = {
      title: property?.property_name || 'Property on PropertyDealsTalk',
      text: `Check out ${property?.property_name || 'this property'} - ${formatPrice(property?.asking_price)} at ${property?.location || 'prime location'}`,
      url: publicUrl
    };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        setToast({
          open: true,
          message: 'Shared successfully!',
          severity: 'success'
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          setShareUrl(publicUrl);
          setSelectedPropertyId(property.id);
          setShareDialog(true);
        }
      }
    } else {
      setShareUrl(publicUrl);
      setSelectedPropertyId(property.id);
      setShareDialog(true);
    }
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'URL copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      setToast({
        open: true,
        message: 'Failed to copy URL',
        severity: 'error'
      });
    }
  };

  const handleCloseShareDialog = () => {
    setShareDialog(false);
    setSelectedPropertyId(null);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast(prev => ({ ...prev, open: false }));
  };

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '1100px',
        p: { xs: '16px', md: '24px' },
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        mb: '24px',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      {error ? (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '300px',
            p: 4,
            textAlign: 'center'
          }}
        >
          <Typography 
            sx={{ 
              color: '#666',
              fontSize: '1.1rem',
              fontWeight: 500,
              maxWidth: '600px',
              ...outfitFontStyle
            }}
          >
            {error}
          </Typography>
        </Box>
      ) : properties.length === 0 ? (
        <Box sx={{ textAlign: 'center', p: 3 }}>
          <Typography sx={outfitFontStyle}>No recently viewed properties found.</Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
            }}
          >
            {getCurrentPageItems().map((property) => {
              const isFavorite = favorites[property.id] || false;
              
              return (
                <Box
                  key={property.id}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    background: '#fff',
                    border: '1px solid #ddd',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    height: { md: '140px', xs: 'auto' },
                    width: '100%',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    },
                  }}
                  onClick={() => handlePropertyClick(property.id)}
                >
                  <Box
                    sx={{
                      width: { md: '300px', xs: '100%' },
                      height: { md: '140px', xs: '180px' },
                      flexShrink: 0,
                      position: 'relative',
                    }}
                  >
                    {property.hasValidImage ? (
                      <Box
                        component="img"
                        src={property.processedImageUrl}
                        alt={property.property_name || 'Property Image'}
                        sx={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderTopLeftRadius: { md: '8px', xs: 0 },
                          borderBottomLeftRadius: { md: '8px', xs: 0 },
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f5f5f5',
                          border: '1px dashed #ccc',
                          borderTopLeftRadius: { md: '8px', xs: 0 },
                          borderBottomLeftRadius: { md: '8px', xs: 0 },
                        }}
                      >
                        <Typography variant="body2" color="#888" textAlign="center" px={2}>
                          No images uploaded
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      ml: { md: '20px', xs: 0 },
                      p: { xs: '16px', md: '10px' },
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        mb: 1,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            fontSize: '18px',
                            mb: 0.5,
                          }}
                        >
                          {property.property_name || 'Unnamed Property'}
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 700,
                            color: '#3b82f6',
                            mb: 1,
                            fontSize: '18px',
                          }}
                        >
                          {formatPrice(property.asking_price)}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '14px',
                            mb: 0.5,
                          }}
                        >
                          {property.area_name || ''}{property.area_name && property.location ? ', ' : ''}{property.location || ''}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '14px',
                          }}
                        >
                          {property.property_type === 'residential' ? 'Residential' : 'Commercial'} {property.asset_type || ''}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          gap: 3,
                          ml: 2,
                          alignItems: 'center',
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ cursor: 'pointer' }}
                          onClick={(e) => toggleFavorite(e, property)}
                        >
                          {isFavorite ? (
                            <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
                          ) : (
                            <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
                          )}
                          <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
                            {isFavorite ? 'Saved' : 'Save'}
                          </Typography>
                        </Box>

                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ cursor: 'pointer' }}
                          onClick={(e) => handleShareClick(e, property)}
                        >
                          <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
                          <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
                            Share
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {!isMobile && (
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '120px',
                          mt: 'auto',
                        }}
                      >
                        {property.bhk && (
                          <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
                            {property.bhk} BHK
                          </Typography>
                        )}
                        {property.furnish_type && (
                          <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
                            {property.furnish_type}
                          </Typography>
                        )}
                        {property.property_size && (
                          <Typography variant="body2" sx={{ ...outfitFontStyle, color: '#6b7280' }}>
                            {property.property_size} {property.property_size_units || 'sq.ft'}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>
         
          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="medium"
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    ...outfitFontStyle,
                    color: '#333',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#2563EB !important',
                    color: 'white',
                  }
                }}
              />
            </Box>
          )}
        </>
      )}

      <Dialog open={shareDialog} onClose={handleCloseShareDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
            Share Property
          </Typography>
          <IconButton onClick={handleCloseShareDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
            Share this property link with others. Anyone with this link can view the property details.
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopyUrl} edge="end" color="primary" title="Copy URL">
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                backgroundColor: '#f5f5f5',
                ...outfitFontStyle 
              } 
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            onClick={handleCloseShareDialog} 
            variant="outlined" 
            sx={outfitFontStyle}
          >
            Close
          </Button>
          <Button 
            onClick={handleCopyUrl} 
            variant="contained" 
            startIcon={<ContentCopyIcon />} 
            sx={outfitFontStyle}
          >
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', ...outfitFontStyle }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProfileViewed;
